import clsx from 'clsx';
import React from 'react';

import Icon from '1_components/Icon/Icon';
import StyledLink from '1_components/StyledLink/StyledLink';

import S from './LinksList.module.scss';

import { fonts } from 'styles/fontsRegistry';

export interface LinksListProps {
  links: {
    label: string;
    url: string;
    sideEffect?: () => void;
  }[];
  className?: string;
}

const LinksList: React.FC<LinksListProps> = ({ links, className, ...rest }) => {
  return (
    <div className={clsx(className, S.LinksWrapper)} {...rest}>
      <ul className={S.LinksList}>
        {links
          .filter(_ => !!_.label)
          .map(({ label, url, sideEffect }, index) => (
            <li className={S.ListItem} key={label}>
              <StyledLink
                href={url}
                icon={!index && <Icon variant="LinkArrow" />}
                target="_blank"
                onClick={sideEffect}
              >
                <span className={fonts.link}>{label}</span>
              </StyledLink>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default LinksList;
